(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-footer"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".footer-accordion");
  const headers = document.querySelectorAll(".footer-accordion-header");

  // ---- OPEN FIRST ACCORDION BY DEFAULT ---- //
  if (accordions.length > 0) {
    const first = accordions[0];
    first.classList.add("active");
    const firstContent = first.querySelector(".footer-accordion-content");
    firstContent.style.maxHeight = firstContent.scrollHeight + "px";
  }

  // ---- OPEN ONE AT A TIME ---- //
  headers.forEach(header => {
    header.addEventListener("click", function () {
      const parent = this.parentElement;

      // If already active, close it
      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
        parent.querySelector(".footer-accordion-content").style.maxHeight = "0px";
        return;
      }

      // Close all
      accordions.forEach(acc => {
        acc.classList.remove("active");
        acc.querySelector(".footer-accordion-content").style.maxHeight = "0px";
      });

      // Open clicked accordion
      parent.classList.add("active");
      const content = parent.querySelector(".footer-accordion-content");
      content.style.maxHeight = content.scrollHeight + "px";
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-tab"] && !Shopify.designMode) return;
  try {
    
  const collectionTab = document.querySelectorAll(".collection-tab-button");
  const collectionTabPanel = document.querySelectorAll(".collection-tab-panel");

  let current = null;

  /* 🔹 Default first tab active */
  // if (collectionTab.length) {
  //   collectionTab[0].classList.add("active");
  // }

  /* 🔹 Click → scroll to tab panel */
  collectionTab.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      if (!targetId || !targetId.startsWith("#")) return;

      const targetSection = document.querySelector(targetId);
      if (!targetSection) return;

      e.preventDefault();

      // Update active immediately on click
      collectionTab.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      const offset = 120; // adjust for sticky header
      const top =
        targetSection.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    });
  });

  /* 🔹 Scroll → update active tab */
  window.addEventListener("scroll", () => {
    collectionTabPanel.forEach((section) => {
      const sectionTop = section.offsetTop;
      if (window.scrollY >= sectionTop - 130) {
        current = section.getAttribute("id");
      }
    });

    if (!current) return;

    collectionTab.forEach((tab) => {
      tab.classList.toggle(
        "active",
        tab.getAttribute("href") === `#${current}`
      );
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const featuredCollectionSlider = document.querySelector('#featured-collection-slider');
    if (featuredCollectionSlider) {
      new Splide(featuredCollectionSlider, {
        perPage: 3,
        perMove: 1,
        speed: 1000,
        rewind: false,
        gap: '22px',
        arrows: true,
        pagination: false,
        breakpoints: {
          1024: {
            perPage: 3
          },
          991: {
            perPage: 2
          },
          767: {
            perPage: 3,
            gap: '11px',
          },
          576: {
            perPage: 2,
          },
        }
      }).mount();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-splide"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  var splide = new Splide('#hotspotSplide', {
    type: 'slide',
    perPage: 1,
    gap: '16px',
    arrows: false,
    pagination: true,
    speed: 600,
    type: 'fade', 
  });

  splide.mount();

  const hotspots = document.querySelectorAll(".hotspot-dot");

  if(hotspots.length > 0){
    hotspots[0].classList.add("active-hotspot");
  }

  splide.on('move', function (newIndex) {
    hotspots.forEach(dot => dot.classList.remove("active-hotspot"));
    hotspots.forEach(dot => {
      if (parseInt(dot.dataset.slide) === newIndex) {
        dot.classList.add("active-hotspot");
      }
    });
  });

  hotspots.forEach(dot => {
    dot.addEventListener("mouseenter", function () {
      hotspots.forEach(d => d.classList.remove("active-hotspot"));
      this.classList.add("active-hotspot");
      const slideIndex = Number(this.dataset.slide);
      splide.go(slideIndex);
    });
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mounts-by-position"] && !Shopify.designMode) return;
  try {
    
  const mbpSection = document.querySelector('.cf-jc-mounts-by-position');

  if (mbpSection) {
    const mbpToggleBtns = mbpSection.querySelectorAll('.mbp-toggle-btn');
    const mbpPillsWrap = mbpSection.querySelector('.mbp-pills:not(.mbp-pills-series)');
    const mbpPills = mbpPillsWrap ? mbpPillsWrap.querySelectorAll('.position-pill') : [];
    const mbpPanels = mbpSection.querySelectorAll('.position-panel');
    const mbpControls = mbpSection.querySelector('.mbp-controls');
    const mbpPlaceholder = mbpSection.querySelector('.mbp-placeholder');
    const mbpSeriesPillsWrap = mbpSection.querySelector('.mbp-pills-series');
    const seriesSection = document.querySelector('.cf-jc-collection-tabs');
    const seriesPanels = seriesSection ? seriesSection.querySelectorAll('.collection-tab-panel') : [];

    if (!seriesSection) {
      const seriesBtn = mbpSection.querySelector('.mbp-toggle-btn[data-view="series"]');
      if (seriesBtn) seriesBtn.style.display = 'none';
    }

    if (seriesSection && mbpSeriesPillsWrap) {
      const seriesTabButtons = seriesSection.querySelectorAll('.collection-tabs .collection-tab-button');
      seriesTabButtons.forEach((btn, i) => {
        const pill = document.createElement('a');
        pill.href = btn.getAttribute('href');
        pill.className = 'position-pill' + (i === 0 ? ' active' : '');
        pill.textContent = btn.textContent.trim();
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          const target = document.querySelector(this.getAttribute('href'));
          if (!target) return;
          mbpSeriesPillsWrap.querySelectorAll('.position-pill').forEach((p) => p.classList.remove('active'));
          this.classList.add('active');
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        mbpSeriesPillsWrap.appendChild(pill);
      });
    }

    function mbpMeasure() {
      const header = document.querySelector('sticky-header');
      const headerBottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 92;
      document.documentElement.style.setProperty('--mbp-sticky-top', (headerBottom + 12) + 'px');
    }
    mbpMeasure();
    window.addEventListener('resize', mbpMeasure);

    function mbpStickyTop() {
      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mbp-sticky-top')) || 104;
    }

    function mbpScrollOffset() {
      const controlsH = mbpControls ? mbpControls.getBoundingClientRect().height : 60;
      return mbpStickyTop() + controlsH + 10;
    }

    function mbpUpdateFixed() {
      if (!mbpControls || !mbpPlaceholder) return;
      mbpMeasure();
      const isFixed = mbpSection.classList.contains('mbp-fixed');
      const anchorEl = isFixed ? mbpPlaceholder : mbpControls;
      const anchorTop = anchorEl.getBoundingClientRect().top + window.pageYOffset;
      const shouldFix = window.scrollY + mbpStickyTop() >= anchorTop;
      if (shouldFix && !isFixed) {
        mbpPlaceholder.style.height = mbpControls.getBoundingClientRect().height + 'px';
        mbpSection.classList.add('mbp-fixed');
      } else if (!shouldFix && isFixed) {
        mbpSection.classList.remove('mbp-fixed');
        mbpPlaceholder.style.height = '0px';
      }
      mbpSection.classList.toggle('mbp-collapsed', window.scrollY > 150);
    }
    mbpUpdateFixed();
    window.addEventListener('resize', mbpUpdateFixed);

    function mbpSetView(view) {
      const showPosition = view !== 'series';
      mbpToggleBtns.forEach((b) => {
        const on = b.dataset.view === (showPosition ? 'position' : 'series');
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.body.classList.toggle('mounts-view-position', showPosition);
      document.body.classList.toggle('mounts-view-series', !showPosition);
      mbpSection.classList.toggle('groups-hidden', !showPosition);
      mbpUpdateFixed();
    }

    mbpToggleBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        mbpSetView(this.dataset.view);
        const sectionTop = mbpSection.getBoundingClientRect().top + window.pageYOffset - 130;
        if (window.scrollY > sectionTop) {
          window.scrollTo({ top: Math.max(sectionTop, 0), behavior: 'auto' });
        }
        mbpUpdateFixed();
      });
    });

    /* Deep links from the header menu: #pos-… jumps to a position group,
       #tab-… switches to the series view first, then jumps to that series. */
    function mbpGoToHash(hash, behavior) {
      if (!hash || hash.length < 2) return false;
      const id = hash.slice(1);
      const isSeries = id.indexOf('tab-') === 0;
      const isPosition = id.indexOf('pos-') === 0;
      if (!isSeries && !isPosition) return false;

      const target = document.getElementById(id);
      if (!target) return false;
      if (isSeries && !seriesSection) return false;

      mbpSetView(isSeries ? 'series' : 'position');

      const pillsWrap = isSeries ? mbpSeriesPillsWrap : mbpPillsWrap;
      if (pillsWrap) {
        pillsWrap.querySelectorAll('.position-pill').forEach((pill) => {
          pill.classList.toggle('active', pill.getAttribute('href') === hash);
        });
      }

      /* Let the view swap lay out before measuring the target. */
      requestAnimationFrame(() => {
        mbpUpdateFixed();
        target.scrollIntoView({ behavior: behavior || 'smooth', block: 'start' });
      });
      return true;
    }

    /* Landing on the page with a hash — run after load so images don't shift it. */
    if (window.location.hash) {
      if (document.readyState === 'complete') {
        mbpGoToHash(window.location.hash, 'auto');
      } else {
        window.addEventListener('load', () => mbpGoToHash(window.location.hash, 'auto'));
      }
    }
    window.addEventListener('hashchange', () => mbpGoToHash(window.location.hash, 'smooth'));

    /* Already on the page: handle the click directly so re-picking the same
       item (no hashchange event) still scrolls. */
    document.addEventListener('click', (event) => {
      const el = event.target instanceof Element ? event.target : null;
      const anchor = el && el.closest('a[href*="#pos-"], a[href*="#tab-"]');
      if (!anchor) return;
      /* The section's own pills, the tab buttons and the mobile drawer keep their
         existing handlers (the drawer needs the real navigation to close itself). */
      if (anchor.closest('.cf-jc-mounts-by-position, .cf-jc-collection-tabs, .menu-drawer')) return;
      const url = new URL(anchor.href, window.location.href);
      if (url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
      if (mbpGoToHash(url.hash, 'smooth')) {
        event.preventDefault();
        if (window.location.hash !== url.hash) {
          history.replaceState(null, '', url.hash);
        }
      }
    });

    mbpPills.forEach((pill) => {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        mbpPills.forEach((p) => p.classList.remove('active'));
        this.classList.add('active');
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    function mbpSpy(panels, pillsWrap, lastId) {
      let current = null;
      const threshold = mbpScrollOffset() + 40;
      panels.forEach((panel) => {
        const panelTop = panel.getBoundingClientRect().top + window.pageYOffset;
        if (window.scrollY >= panelTop - threshold) {
          current = panel.getAttribute('id');
        }
      });
      if (!current || current === lastId) return lastId;
      const pills = pillsWrap.querySelectorAll('.position-pill');
      pills.forEach((pill) => {
        const on = pill.getAttribute('href') === '#' + current;
        pill.classList.toggle('active', on);
        if (on && pillsWrap.scrollWidth > pillsWrap.clientWidth) {
          pillsWrap.scrollTo({ left: Math.max(pill.offsetLeft - 20, 0), behavior: 'smooth' });
        }
      });
      return current;
    }

    let mbpLastPos = null;
    let mbpLastSeries = null;
    window.addEventListener('scroll', () => {
      mbpUpdateFixed();
      if (document.body.classList.contains('mounts-view-position')) {
        if (mbpPillsWrap) mbpLastPos = mbpSpy(mbpPanels, mbpPillsWrap, mbpLastPos);
      } else if (mbpSeriesPillsWrap && seriesPanels.length) {
        mbpLastSeries = mbpSpy(seriesPanels, mbpSeriesPillsWrap, mbpLastSeries);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outlast-product"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const items = document.querySelectorAll(".outlast-product");
        if (items.length > 0) {
            items[0].classList.add("hovered");
        }
        items.forEach((item) => {
            item.addEventListener("mouseenter", () => {
            items.forEach((i) => i.classList.remove("hovered"));
            item.classList.add("hovered");
            });
            item.addEventListener("mouseleave", () => {
            });
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
        new Splide('#outlastSplide', {
            perPage: 2,
            gap: '10px',
            pagination: false,
            arrows: false,
            autoplay: false,
            padding: {
                left: '0',
                right: '20px'
            },
            breakpoints: {
                576: {
                    perPage: 1   
                }
            }
        }).mount();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  const tabs = document.querySelectorAll(".tab-main");
  const panes = document.querySelectorAll(".product-tab-pane");

  let current = null;

  /* The Reviews pane is an empty placeholder — resolve it to the reviews app widget below.
     Yotpo also renders a star badge near the product title, so only accept a widget
     that comes AFTER the placeholder in the document. */
  function resolveTarget(selector) {
    if (selector === "#compare") {
      const comp = document.querySelector(
        ".tt-compare-section, .tt-compare, .tt-compare__card, .tt-compare__table"
      );
      if (comp) return comp.closest(".shopify-section") || comp;
      return null;
    }
    const pane = document.querySelector(selector);
    if (!pane) return null;
    if (pane.classList.contains("product-tab-pane") && pane.children.length === 0) {
      const candidates = document.querySelectorAll(
        ".yotpo-widget-instance, [data-yotpo-instance-id], .yotpo"
      );
      for (const el of candidates) {
        if (pane.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) {
          return el.closest(".shopify-section") || el;
        }
      }
    }
    return pane;
  }

  /* 🔹 Default first tab active */
  if (tabs.length) {
    tabs[0].classList.add("active");
  }

  /* 🔹 Click → scroll to section */
  tabs.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      if (!targetId || !targetId.startsWith("#")) return;

      const targetSection = resolveTarget(targetId);
      if (!targetSection) return;

      e.preventDefault();

      // Remove active from all
      tabs.forEach((t) => t.classList.remove("active"));
      this.classList.add("active");

      const offset = 120; // adjust for sticky header
      const top =
        targetSection.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    });
  });

  /* 🔹 Scroll → update active tab (tabs are in page order, so the last one
     whose target we've scrolled past wins) */
  window.addEventListener("scroll", () => {
    tabs.forEach((tab) => {
      const spyEl = resolveTarget(tab.getAttribute("href"));
      if (!spyEl) return;
      const sectionTop = spyEl.getBoundingClientRect().top + window.scrollY;
      if (window.scrollY >= sectionTop - 130) {
        current = tab.getAttribute("href");
      }
    });

    if (!current) return;

    tabs.forEach((tab) => {
      tab.classList.toggle("active", tab.getAttribute("href") === current);
    });
  });


  /* accordion */
  const faqItems = document.querySelectorAll(".faq-item");

  function closeItem(item) {
    const button = item.querySelector(".faq-header");
    const body = item.querySelector(".faq-body");

    item.classList.remove("is-open");
    button.setAttribute("aria-expanded", "false");
    body.style.maxHeight = 0;
  }

  function openItem(item) {
    const button = item.querySelector(".faq-header");
    const body = item.querySelector(".faq-body");

    item.classList.add("is-open");
    button.setAttribute("aria-expanded", "true");
    body.style.maxHeight = body.scrollHeight + "px";
  }

  // Initialize open/closed state
  faqItems.forEach((item) => {
    const body = item.querySelector(".faq-body");
    if (item.classList.contains("is-open")) {
      body.style.maxHeight = body.scrollHeight + "px";
    } else {
      body.style.maxHeight = 0;
    }
  });

  // Click behavior (only one open at a time)
  faqItems.forEach((item) => {
    const button = item.querySelector(".faq-header");

    button.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");

      faqItems.forEach((faq) => closeItem(faq));

      if (!isOpen) {
        openItem(item);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
